module.exports = __webpack_public_path__ + "img/resource-tech-image-18.1ee04318.jpg";